import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import OptimizerCreator from "components/Optimizer/OptimizerCreator";

import * as optimizerCreatorReducer from "containers/OptimizerCreator/reducer";
import * as optimizerReducer from "containers/Optimizer/reducer";

class OptimizerCreatorContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return <OptimizerCreator {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateFirstRunId: (firstRunId) => dispatch(optimizerCreatorReducer.updateFirstRunId(firstRunId)),
    updateSecondRunId: (secondRunId) => dispatch(optimizerCreatorReducer.updateSecondRunId(secondRunId)),

    updateOverallColumn: (overallColumn) => dispatch(optimizerCreatorReducer.updateOverallColumn(overallColumn)),
    updateFirstColumn: (marketingColumn) => dispatch(optimizerCreatorReducer.updateFirstColumn(marketingColumn)),
    updateSecondColumn: (salesColumn) => dispatch(optimizerCreatorReducer.updateSecondColumn(salesColumn)),

    handleCreate: () => dispatch(optimizerCreatorReducer.handleCreate())
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    firstDataset: optimizerCreatorReducer.getFirstDataset(state),
    secondDataset: optimizerCreatorReducer.getSecondDataset(state),
    optimizers: optimizerReducer.getOptimizers(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(OptimizerCreatorContainer);
